export const pageSize = 14;
